import { render, staticRenderFns } from "./Toppers.vue?vue&type=template&id=3fe2bb9e"
import script from "./Toppers.vue?vue&type=script&lang=js"
export * from "./Toppers.vue?vue&type=script&lang=js"
import style0 from "./Toppers.vue?vue&type=style&index=0&id=3fe2bb9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports